class HCLDX {
    static baseURL() {
        let r = this.get_REACT_APP_HCL_DX_BASE_URL();
        let u = '';
        if (r !== undefined) {
            u = r;
            if (window.avnet !== undefined &&
                window.avnet.siteId !== undefined) {
                u += window.avnet.siteId;
            }
        }
        return u;
    }

    static baseURLOfHCLDX() {
        return this.get_REACT_APP_HCL_DX_DOMAIN();
    }

    static get_REACT_APP_HCL_DX_BASE_URL() {
        const hostname = window.location.href;
        if (hostname.includes('my.uat.avnet.com')) {
            return 'https://my.uat.avnet.com/';
        } else if (hostname.includes('onesite-uat5.avnet.com')) {
            return 'https://onesite-uat5.avnet.com/';
        } else if (hostname.includes('dx-dev.avnt.now.hclsoftware.cloud')) {
            return 'https://dx-dev.avnt.now.hclsoftware.cloud/';
        } else if (hostname.includes('dx-qa.eu.avnt.now.hclsoftware.cloud')) {
            return 'https://dx-qa.eu.avnt.now.hclsoftware.cloud/';
        } else if (hostname.includes('dx-qa.us.avnt.now.hclsoftware.cloud')) {
            return 'https://dx-qa.us.avnt.now.hclsoftware.cloud/';
        } else if (hostname.includes('dxauth-prd.us.avnt.now.hclsoftware.cloud')) {
            return 'https://dxauth-prd.us.avnt.now.hclsoftware.cloud/';
        } else if (hostname.includes('dx-qa.ap.avnt.now.hclsoftware.cloud')) {
            return 'https://dx-qa.ap.avnt.now.hclsoftware.cloud/';
        } else if (hostname.includes('my.uat.cloud.avnet.com')) {
            return 'https://my.uat.cloud.avnet.com/';
        } else if (hostname.includes('www.uat.cloud.avnet.com')) {
            return 'https://www.uat.cloud.avnet.com/';
        } else if (hostname.includes('my.authoring.cloud.avnet.com')) {
            return 'https://my.authoring.cloud.avnet.com/';
        } else if (hostname.includes('my.cloud.avnet.com')) {
            return 'https://my.cloud.avnet.com/';
        } else if (hostname.includes('www.cloud.avnet.com')) {
            return 'https://www.cloud.avnet.com/';
        } else if (hostname.includes('dxlive-prd.us.avnt.now.hclsoftware.cloud')) {
            return 'https://dxlive-prd.us.avnt.now.hclsoftware.cloud/';
        } else if (hostname.includes('dxlive-prd.eu.avnt.now.hclsoftware.cloud')) {
            return 'https://dxlive-prd.eu.avnt.now.hclsoftware.cloud/';
        } else if (hostname.includes('dxlive-prd.ap.avnt.now.hclsoftware.cloud')) {
            return 'https://dxlive-prd.ap.avnt.now.hclsoftware.cloud/';
        }
        return process.env.REACT_APP_HCL_DX_BASE_URL;
    }

    static get_REACT_APP_HCL_DX_DOMAIN() {
        return process.env.REACT_APP_HCL_DX_DOMAIN;
    }
}

export default HCLDX;